import { RootStateCarteira } from '../../store/carteiraReducer';
import * as S from './styles';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { PageBanner } from 'base/src/components/PageBanner';
import Avatar from 'base/src/components/Avatar';
import { useTheme } from 'base/src/utils/context/themeContext';
import StringUtil from 'domain/utils/StringUtils';
import { Tag } from 'base/src/components/Tag';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GetPagamentoDetalhe, GetPagamentoDetalheByExtratoID } from '../../store/pagamento/actions/pagamentoAction';
import Divider from 'base/src/components/Divider';
import { Row } from 'base/src/components/Basic/Row/row';
import { PedidosPagosResponse } from '../../types/detalheResgate/pedidosPagos';
import { DetalhePagamentoResponse } from '../../types/detalheResgate/detalhePagamentoResponse';
import { PagosResponse } from '../../types/detalheResgate/pagos';
import { formatDate } from 'base/src/utils/stringUtil';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    DetalheResgate: state.PagamentoReducer.PagamentoDetalhe,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  { GetPagamentoDetalhe, GetPagamentoDetalheByExtratoID }
);

export interface DetalhePagamentoComponentProps extends PropsFromRedux<typeof connector> {}

interface GroupedData {
  avatar: string;
  usuarioNome: string;
  pedidos: (PedidosPagosResponse & { status: string })[];
}

function DetalhePagamento(props: DetalhePagamentoComponentProps){
  const { theme } = useTheme();
  const { id } = useParams();

  useEffect(() => {

    const num : number = Number(id);
    if(isNaN(num)){
      //@ts-expect-error bruh idk 
      props.GetPagamentoDetalhe(id, props.CarteiraUsuario[0].CarteiraID, () => { });
    }else{
      props.GetPagamentoDetalheByExtratoID({
        ExtratoID: num,
        CarteiraID: props.CarteiraUsuario[0].CarteiraID,
        DataOperacao: ''
      }, props.CarteiraUsuario[0].CarteiraID, () => { });
    }

    
  }, [])

  const groupedData = props.DetalheResgate.flatMap((resgate: DetalhePagamentoResponse) =>
    resgate.Pagos
  ).reduce<Record<string, GroupedData>>((acc, pagosItem: PagosResponse) => {
    const key = `${pagosItem.Avatar}-${pagosItem.UsuarioNome}`;

    if (!acc[key]) {
      acc[key] = {
        avatar: pagosItem.Avatar,
        usuarioNome: pagosItem.UsuarioNome,
        pedidos: [],
      };
    }

    pagosItem.PedidosPagos.forEach((pedidoItem: PedidosPagosResponse) => {
      acc[key].pedidos.push({
        ...pedidoItem,
        status: pagosItem.Status,
      });
    });

    return acc;
  }, {});
  const totalValorTransacao = props.DetalheResgate.reduce((total, item) => {
    return total + Number(item.ValorTransacao);
  }
  , 0);
  const totalQuantidadePremiacoesPagas = props.DetalheResgate.reduce((total, item) => {
    return total + Number(item.QuantidadePremiacoesPagas);
  }
  , 0);
  return (
    <S.Container>
      <PageBanner title="Detalhe Pagamento" subtile="Visualize todos os detalhes desta transação" />
      {props.DetalheResgate.length > 0 && (
        <S.InfoContainer>
          <S.OrderHeader>
            <S.OrderDetails>
              <S.OrderItem>
                <S.Column style={{ display: "flex", flexDirection: "column" }}>
                  <S.HeaderTitle>Pedido Realizado</S.HeaderTitle>
                  <span>{formatDate(props.DetalheResgate[0].DataOperacao)}</span>
                </S.Column>
                <S.Column style={{ display: "flex", flexDirection: "column" }}>
                  <S.HeaderTitle>Total</S.HeaderTitle>
                  <span>{formatToBRL(totalValorTransacao)}</span>
                </S.Column>
                <S.Column style={{ display: "flex", flexDirection: "column" }}>
                  <S.HeaderTitle>Pessoa(s) Paga(s)</S.HeaderTitle>
                  <span>{props.DetalheResgate[0].QuantidadePessoasPagas}</span>
                </S.Column>
                <S.Column style={{ display: "flex", flexDirection: "column" }}>
                  <S.HeaderTitle>Premiação(ões) Paga(s)</S.HeaderTitle>
                  <span>{totalQuantidadePremiacoesPagas}</span>
                </S.Column>
              </S.OrderItem>
            </S.OrderDetails>
          </S.OrderHeader>
          <S.PedidoWrapper>
            {Object.values(groupedData).map(({ avatar, usuarioNome, pedidos }) => (
              <div key={avatar + usuarioNome} style={{paddingInline: 30}}>
                
                <div style={{ alignItems:'space-between', display: 'flex', flexDirection: 'row', gap: 10 }}>
                  <div style={{flex: 1}}>

                
                    {pedidos.map((pedidoItem) => (
                      <S.PedidoContent key={pedidoItem.CarteiraSaqueID}>
                        <div style={{ display: "flex", alignItems: "center", gap: 15, paddingInline: 10, width: '17%' }}>
                          <div style={{ width: 85, height: 85, minWidth: 85, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                            <img
                              src={pedidoItem.Imagem}
                              alt="user avatar"
                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }}
                            />
                          </div>
                        </div>


                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, width: '100%' }}>
                            <Row style={{ gap: 10, width: '100%' }}>
                              <S.ContentTitle style={{ width: 100, flexShrink: 0 }}>Premiação: </S.ContentTitle>
                              <span>{pedidoItem.Nome}</span>
                            </Row>
                            <Row style={{ gap: 10, width: '100%' }}>
                              <S.ContentTitle style={{ width: 100, flexShrink: 0 }}>Valor:</S.ContentTitle>
                              <span>{formatToBRL(pedidoItem.ValorOriginal)} {pedidoItem.Qtde > 1 ? "(" + pedidoItem.Qtde + "x " + formatToBRL(pedidoItem.ValorUnitario) +")" : ""}</span>
                            </Row>
                            <Row style={{ gap: 10, width: '100%' }}>
                              <S.ContentTitle style={{ width: 100, flexShrink: 0 }}>Taxas:</S.ContentTitle>
                              <span>{formatToBRL(Number(pedidoItem.ValorTotal) - Number(pedidoItem.ValorOriginal))}</span>
                            </Row>
                            <Row style={{ gap: 10, width: '100%' }}>
                              <S.ContentTitle style={{ width: 100, flexShrink: 0 }}>Status: </S.ContentTitle>
                              <Tag variant={pedidoItem.status === "DONE" ? "positive" : pedidoItem.status === "PENDING" ? "warning" : "danger"}>
                                <span style={{ fontSize: 10 }}>{pedidoItem.status === "DONE" ? "Confirmado" : pedidoItem.status === "PENDING" ? "Pendente" : "Cancelado"}</span>
                              </Tag>
                            </Row>

                          </div>
                          
                        
                      </S.PedidoContent>
                    ))}

                    { totalQuantidadePremiacoesPagas > 0 ?
                    <div style={{ display: "flex", alignItems: "center", paddingInline: 10, width: '100%' }}>
                      <div style={{ width: 95, flexShrink: 0 }}></div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 5, paddingLeft: 10, width: '100%' }}>
                        <Row style={{ gap: 10, width: '100%' }}>
                          <S.ContentTitle style={{ width: 100, flexShrink: 0 }}>Sub Total: </S.ContentTitle>
                          <span>{formatToBRL(pedidos.reduce((total, item) => total + Number(item.ValorTotal), 0))}</span>
                        </Row>
                      </div>
                    </div>
                    : <></>}

                    </div>

                    <div style={{ display: "flex", alignItems: 'flex-start', paddingTop: 10, paddingBottom: 10, flexDirection: 'column' }}>
                        <S.ContentTitle>Solicitado por:</S.ContentTitle>
                        <div style={{ paddingTop: 10}}>
                          <S.ContentTitle style={{paddingRight: 15}}>{usuarioNome}</S.ContentTitle>
                          <Avatar
                            src={avatar}
                            borderColor={theme.colors.primary}
                            size="sm"
                            alt="user avatar"
                            fallBack={StringUtil.GetFirstLetters(usuarioNome)}
                          />
                        </div>
                      </div>

                </div>
                
                <Divider orientation='horizontal' color={theme.colors.border_grey} />
                
              </div>

            ))}

          </S.PedidoWrapper>

          <S.PedidoFooter />
        </S.InfoContainer >
      ) }
    </S.Container >

  )
}


export default connector(DetalhePagamento);